import { lazy } from "react";
import { useNavigate, useRoutes, Navigate } from "react-router-dom";

import MainLayout from "Layout/mainlayout";
import CachedService from "Classes/cachedService";

// const Home = lazy(() => import("Pages/Home"));
const Stake = lazy(() => import("Pages/Stake"));
const Topup = lazy(() => import("Pages/Topup"));
const NodeStaking = lazy(() => import("Pages/NodeStaking"));
const InvestmentFunds = lazy(() => import("Pages/InvestmentFunds"));
const ProtocolsPercentages = lazy(() => import("Pages/HedgeFundAdmin/protocolsPercentages"));
const ProtocolsMetadata = lazy(() => import("Pages/HedgeFundAdmin/protocolsMetadata"));
const Snapshots = lazy(() => import("Pages/HedgeFundAdmin/snapshots"));

export default function Routes() {
  const navigate = useNavigate();
  CachedService.navigation = navigate;

  return useRoutes([
    {
      path: "/",
      element: (
        <MainLayout>
          <InvestmentFunds />
        </MainLayout>
      ),
    },
    {
      path: "/hit-staking",
      element: (
        <MainLayout>
          <Stake />
        </MainLayout>
      ),
    },
    {
      path: "/admin",
      element: (
        <MainLayout>
          <Topup />
        </MainLayout>
      ),
    },
    {
      path: "/admin/hedge-fund/protocols-metadata",
      element: (
        <MainLayout>
          <ProtocolsMetadata />
        </MainLayout>
      ),
    },
    {
      path: "/admin/hedge-fund/protocols-percentage",
      element: (
        <MainLayout>
          <ProtocolsPercentages />
        </MainLayout>
      ),
    },
    {
      path: "/admin/hedge-fund/snapshots",
      element: (
        <MainLayout>
          <Snapshots />
        </MainLayout>
      ),
    },
    {
      path: "/node-staking",
      element: (
        <MainLayout>
          <NodeStaking />
        </MainLayout>
      ),
    },
    {
      path: "/fund",
      element: (
        <MainLayout>
          <InvestmentFunds />
        </MainLayout>
      ),
    },
    { path: "*", element: <Navigate to={"/"} replace={true} /> },
  ]);
}
